<template>
	<div>
		<div class="fixed top-0 right-5 w-fit h-fit z-[30]">
			<LanguageSelector />
		</div>
		<LandingPage />
		<MultiApartmentAboutPage />	
		<RentBikePage />
		<RequestPage />
		<InfoPage />

		<PhotoGallery
			:gallery-open="globalStore.galleryImages !== null"
			@close="globalStore.galleryImages = null"
		/>
	</div>
</template>

<script>
import LandingPage from '../components/LandingPage.vue';
import LanguageSelector from '../components/graphics/LanguageSelector.vue';
import RequestPage from '../components/RequestPage.vue';
import InfoPage from '../components/InfoPage.vue';
import MultiApartmentAboutPage from '../components/MultiApartmentAboutPage.vue';
import PhotoGallery from '@/components/graphics/PhotoGallery.vue';
import RentBikePage from '@/components/RentBikePage.vue';

import { useGlobalStore } from '@/stores/global';

export default {
	name: 'HomeView',
	components: {
		LandingPage,
		RequestPage,
		InfoPage,
		MultiApartmentAboutPage,
		LanguageSelector,
		PhotoGallery,
		RentBikePage,
	},
	setup() {
		return {
			globalStore: useGlobalStore()
		};
	},
}
</script>
